import React from "react";
import styled from "styled-components";
import { PanelResult } from "common/panel/dto/PanelResult";
import PanelSingleNav from "components/common/panel/PanelSingleNav";
import PanelPlay from "components/common/panel/PanelPlay";
import { staticContentPath } from "common/static_content_common";

type PanelReadProps = {
  panel: PanelResult;
};

const PanelRead = ({ panel }: PanelReadProps) => {
  return (
    <div>
      <DivField>{panel.datum.toDateString()}</DivField>
      <DivField>{panel.title}</DivField>
      <DivField>
        {panel.fileName && (
          <PanelPlay
            filePath={staticContentPath(panel.fileName)}
            autoPlay={false}
            muted={true}
            width={500}
          />
        )}
      </DivField>

      <DivNav>
        <PanelSingleNav panel={panel} hideReadNav={true} />
      </DivNav>
    </div>
  );
};

const DivField = styled.div`
  margin-top: 0.5rem;
  font-size: 1.2rem;

  &&&:first-of-type {
    margin-top: 0rem;
  }
`;

const DivNav = styled.div`
  margin-top: 1.5rem;
`;

export default PanelRead;
